import { Button, Result } from 'antd';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

function NotFound() {
    const navigate = useNavigate();
    const { t } = useTranslation(['common']);

    return (
        <div
            style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
            <Result
                status="404"
                title={t('404.title')}
                subTitle={t('404.subTitle')}
                extra={
                    <Button type="primary" onClick={() => navigate('/')} style={{ height: '48px', width: '100%' }}>
                        {t('404.button')}
                    </Button>
                }
            />
        </div>
    );
}

export default NotFound;
